/* tslint:disable */

import {
  Button,
  Input,
  ListPicker,
  ToolbarFlyout,
  WithStyles,
  createStyles,
  withStyles,
} from '@robotsnacks/ui';
import React, { Component } from 'react';
import { debounce, get, noop } from 'lodash';
import { Link } from '@robotsnacks/icons';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

const query = gql`
  query pages($first: Int, $after: Cursor, $query: String) {
    pages(first: $first, after: $after, query: $query) {
      edges {
        node {
          id
          title
          description
          path
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

const styles = createStyles<'root'>(theme => ({
  root: {
    fontSize: 13,
    width: 280,
  },
}));

export interface PageListFlyoutProps {
  onSelect?: (page: any) => void;
  onSaveClick?: (href: string) => void;
  href?: string;
  onFocus?: () => void;
  onBlur?: () => void;
}

const defaultProps = Object.freeze({
  onDeleteClick: noop,
  onSaveClick: noop,
});

type Props = WithStyles<PageListFlyoutProps, typeof styles> &
  typeof defaultProps;

interface State {
  href?: string;
  in?: boolean;
  view?: 'internal' | 'external';
  query?: string;
}

const getInitialState = (props: Props): State => ({
  href: props.href || '',
  in: false,
  view: props.href ? 'external' : 'internal',
});

class PageListFlyout extends Component<Props, State> {
  public static defaultProps = defaultProps;
  public state = getInitialState(this.props);

  private focused: boolean = false;
  private focusTimer: any;

  public componentWillUnmount() {
    if (this.focusTimer) {
      clearTimeout(this.focusTimer);
    }
  }

  public render() {
    const { classes } = this.props;
    let fetchingMore = false;
    const flyout = (
      <div className={classes.root}>
        <div>
          <div style={{ padding: '0.5rem' }}>
            <input
              onChange={e => this._handleSearchChange(e.currentTarget.value)}
              placeholder="Search"
              style={{
                border: 'none',
                borderBottom: '1px solid #eee',
                outline: 'none',
                width: '100%',
              }}
            />
          </div>
          <Query
            fetchPolicy="network-only"
            query={query}
            variables={{ first: 15, query: this.state.query }}
          >
            {({ data, loading, fetchMore, ...rest }) => {
              const pages = get(data, 'pages.edges', [])
                .map((edge: any) => edge.node)
                .map((node: any) => ({
                  key: node.id,
                  label: node.title || 'Untitled',
                  value: node,
                }));
              return (
                <ListPicker
                  onScroll={e => {
                    const {
                      offsetHeight,
                      scrollHeight,
                      scrollTop,
                    } = e.currentTarget;
                    if (
                      !loading &&
                      !fetchingMore &&
                      data &&
                      data.pages &&
                      data.pages.pageInfo.hasNextPage &&
                      scrollHeight - scrollTop - offsetHeight < 200
                    ) {
                      fetchingMore = true;
                      fetchMore({
                        updateQuery: (prev, { fetchMoreResult }) => {
                          if (!fetchMoreResult) {
                            return prev;
                          }
                          return {
                            ...prev,
                            pages: {
                              ...prev.pages,
                              edges: [
                                ...prev.pages.edges,
                                ...fetchMoreResult.pages.edges,
                              ],
                              pageInfo: fetchMoreResult.pages.pageInfo,
                            },
                          };
                        },
                        variables: {
                          first: 15,
                          after: data.pages.pageInfo.endCursor,
                          query: this.state.query,
                        },
                      });
                    }
                  }}
                  onSelect={this._handleSelect}
                  options={pages}
                />
              );
            }}
          </Query>
        </div>
      </div>
    );

    return (
      <ToolbarFlyout
        flyout={flyout}
        in={this.state.in}
        onFocus={this._handleFocus}
        onBlur={this._handleBlur}
      >
        <Link />
      </ToolbarFlyout>
    );
  }

  private _handleSearchChange = debounce((query: string) => {
    this.setState({ query });
  });

  private _handleSelect = (page: any) => {
    if (this.props.onSelect) {
      this.props.onSelect(page);
    }
    this.setState({ in: false });
  };

  private _handleCancelClick = () => {
    this.setState({ in: false });
  };

  private _handleDeleteClick = () => {
    this.setState({ in: false });
    this.props.onDeleteClick();
  };

  private _handleFocus = () => {
    this.focused = true;
    this.setState({ in: true });
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  };

  private _handleBlur = () => {
    this.focused = false;
    this.focusTimer = setTimeout(() => {
      if (this.focused === false) {
        this.setState({ in: false });
        if (this.props.onBlur) {
          this.props.onBlur();
        }
      }
    }, 20);
  };
}

export default withStyles(styles)(PageListFlyout);
